import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeScreen } from './navigation.action'
import { changeNotify } from './notify.action'
import { changeAlert } from './alert.action'

export const actionTypes = {
    INDEX: 'GOOGLE_INDEX',
    STORE: 'GOOGLE_STORE',
    UPDATE: 'GOOGLE_UPDATE',
    DESTROY: 'GOOGLEL_DESTROY',
    CHANGE: 'GOOGLE_CHANGE',
    SUCCESS: 'GOOGLE_SUCCESS',
    ERROR: 'GOOGLE_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX 

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/google-tag-manager?'+ new URLSearchParams(query))
            .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data, isLoadMore)))
}

// STORE

export const store = (data) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        block: true
    }))

    return HttpAuth.post('/google-tag-manager', data)
    .then(res => {
        if(typeof res !== 'undefined') {
            if(res.data.success === 200) {
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
                dispatch(change('clear'))
                dispatch(changeLoading({ open: false }))
                dispatch(success(true))
                dispatch(changeScreen({ open: false }))
            }
        }
    })
    .catch(erro => {
        if(erro.response) {
            if(erro.response.data.msg) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: 'error'
                }))
            }
        }
        dispatch(changeLoading({ open: false }))
    })
}

// SHOW

export const show = (id) => dispatch => {
    return HttpAuth.get('/google-tag-manager/'+ id)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(erro => {
            if(erro.response) {
                dispatch(changeNotify({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class
                }))
                dispatch(success(true))
            }
        })
}

// UPDATE

export const updateResponse = (payload) => ({
    type: actionTypes.UPDATE,
    payload
})

export const update = (id, data) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        block: true
    }))

    return HttpAuth.put('/google-tag-manager/'+id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    dispatch(success(true))
                    dispatch(changeScreen({ open: false }))
                }
            }
        })
        .catch(erro => {
            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: 'error'
                    }))
                }
            }
            dispatch(changeLoading({ open: false }))
        })
}

// DESTROY

export const destroyResponse = (payload) => ({
    type: actionTypes.DESTROY,
    payload
})

export const destroy = (id) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        msg: 'Apagando...'
    }))

    return HttpAuth.delete('/google-tag-manager/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false, msg: 'Carregando...' }))
            if(typeof res !== 'undefined') {
                dispatch(destroyResponse(id))
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
            }
        })
}